var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M.162 0h7.62v7.619H.161V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M8.543 0h7.619v7.619H8.543V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M.162 8.382h7.62V16H.161V8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M8.543 8.382h7.619V16H8.543V8.38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.162 0h16v16h-16z"
  })))));
};
export default SvgMicrosoft;